import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import {
  rand,
  randFullName,
  randMask,
  randCompanyName,
  randState,
  randStreetAddress,
  randZipCode,
  randCity,
  randChanceBoolean,
} from '@ngneat/falso'

import type { AlternativePayerData } from '@/composables/alternativePayers.js'
import type { MockServer } from './server.js'

export const model = (Model as ModelDefinition<AlternativePayerData>).extend({})

export const factory = Factory.extend<AlternativePayerData>({
  name() {
    return randFullName()
  },
  id_number() {
    return randMask('##########').toString()
  },
  organization_name() {
    return randCompanyName()
  },
  register_number() {
    return randMask('#########').toString()
  },
  street_address() {
    return randStreetAddress()
  },
  street_address_2() {
    if (this.country === 'US' && randChanceBoolean({ chanceTrue: 0.3 })) {
      return randStreetAddress()
    }
    return undefined
  },
  street_address_3() {
    if (randChanceBoolean({ chanceTrue: 0.1 }) && this.country === 'US') {
      return randStreetAddress()
    }
    return undefined
  },
  zip_code() {
    return randZipCode()
  },
  city() {
    return randCity()
  },
  state() {
    return rand(['CA', 'NY', 'TX', 'FL', undefined])
  },
  country() {
    return rand(['GB', 'NL', 'FI', 'US'])
  },
  country_region() {
    return rand([randState(), undefined])
  },
})

export function routes(server: MockServer) {
  server.resource('alternativePayer')
}

export function seeds(server: MockServer) {
  server.create('alternativePayer', {
    id: '1',
    name: 'Alternative Payer (US)',
    id_number: '1234567890',
    organization_name: 'Organization (US)',
    register_number: '1234567890',
    street_address: '123 Main St',
    street_address_2: 'Apt 1',
    street_address_3: 'Apt 2',
    zip_code: '12345',
    city: 'New York',
    state: 'NY',
    country: 'US',
    country_region: 'NY',
  })
  server.create('alternativePayer', {
    id: '2',
    name: 'Alternative Payer (NL)',
    id_number: '0987654321',
    organization_name: 'Organization (NL)',
    register_number: '0987654321',
    street_address: '123 Main St',
    street_address_2: 'Apt 1',
    street_address_3: 'Apt 2',
    zip_code: '6789',
    city: 'Amsterdam',
    state: 'NH',
    country: 'NL',
    country_region: 'NH',
  })
  server.create('alternativePayer', {
    id: '3',
    name: 'Alternative Payer (FI)',
    id_number: '1234567890',
    organization_name: 'Organization (FI)',
    register_number: '1234567890',
    street_address: '123 Main St',
    street_address_2: 'Apt 1',
    zip_code: '12345',
    city: 'Helsinki',
    state: 'Uusimaa',
    country: 'FI',
    country_region: 'Uusimaa',
  })
  server.create('alternativePayer', {
    id: '4',
    name: 'Alternative Payer (GB)',
    id_number: '1234567890',
    organization_name: 'Organization (GB)',
    register_number: '1234567890',
    street_address: '123 Main St',
    zip_code: '12345',
    city: 'London',
    state: 'London',
    country: 'GB',
    country_region: 'London',
  })
}
